
import { Project } from '../types';

export const hiveWheelOfLuck: Project = {
  id: 'hive-wheel-of-luck',
  title: 'Hive Wheel of Luck',
  description: 'A fun, provably fair wheel game utilizing Hive Comments.',
  longDescription: 'Description',
  image: 'https://images.hive.blog/0x0/https://files.peakd.com/file/peakd-hive/louis88/23yHgX1gXBcNK12wMRx2ztjNieDU6fJahUq9RvHbbdEQbdbaCFEyAiiMVfM8HWm8W7kaF.png',
  tags: ['Gaming', 'RNG', 'React', 'Blockchain'],
  link: 'https://hive-wheelof-luck.vercel.app/', 
  github: 'https://github.com/louis-88/HiveWheelofLuck',
  announcementUrl: 'https://peakd.com/hive-139531/@louis88/hivefortune-raffle-winners-through-hive-comments-made-on-blog-posts',
  featured: false
};
